const CITIES = [
  {
    name: "Curitiba",
    phone: "(41) 3797-1357"
  },
  {
    name: "Canoas",
    phone: "(51) 3191-7385"
  },
  {
    name: "Caxias do Sul",
    phone: "(54) 3699-9001"
  },
  {
    name: "Florianópolis",
    phone: "(48) 3197-1425"
  },
  {
    name: "Joinville",
    phone: "(47) 3091-0315"
  },
  {
    name: "Londrina",
    phone: "(43) 4052-9634"
  },
  {
    name: "Maringá",
    phone: "(44) 3112-2518"
  },
  {
    name: "Novo Hamburgo",
    phone: "(51) 3191-7385"
  },
  {
    name: "Pelotas",
    phone: "(53) 3199-1009"
  },
  {
    name: "Porto Alegre",
    phone: "(51) 3191-7385"
  },
  {
    name: "Rio Grande",
    phone: "(53) 3199-1009"
  },
  {
    name: "Santa Maria",
    phone: "(55) 3198-1548"
  }
];

function getPhone(cityName) {
  return CITIES.find(el => el.name === cityName).phone;
}

export default {
  getPhone
};



// WEBPACK FOOTER //
// ./src/utils/states/cities.js